// Port of api/fuel/app/classes/filter/search/games/sorts/query/comment.php
import { sorted, sortReverse, sortPriority } from 'offline/filter/core/search/unit'
export default {
	name: 'comment',
	post: false,
	require: function(config, filter) { return sorted('comment', filter) > 0 },
	run: function(config, filter, data, query) {
		query.order('m.comment_text', sortReverse('comment', filter), sortPriority('comment', filter))
	}
}
